import { RuleAction } from '../enums/POR/RuleAction';
import { RuleOperation } from '../enums/POR/RuleOperation';
import { PortOpeningRequestsDirection } from '../enums/POR/PortOpeningRequestsDirection';
import { AWSRuleRegion } from '../enums/POR/AWSRuleRegion';
import { TrafficDirection } from '../enums/POR/TrafficDirection';
import { AWSPortOpeningRequestsTypes } from '../enums/POR/AWSPortOpeningRequestType';

export default class AWSPortOpeningRule {
	id!: number;

	portOpeningRequestId!: number;

	action!: RuleAction;

	operation!: RuleOperation;

	description!: string;

	sourceIPs!: string;

	destinationIPs!: string;

	destinationURLs!: string;

	sourceURLs!: string;

	trafficDirection: TrafficDirection;

	sourcePorts!: string;

	service!: string;

	name!: string;

	awsName!: string;

	direction!: PortOpeningRequestsDirection;

	type!: AWSPortOpeningRequestsTypes

	destinationPorts!: { protocol: string; destinationPorts: string }[];

	region!: AWSRuleRegion;

	sendDND!: boolean;

	constructor(obj: any) {
		Object.assign(this, obj);
		this.direction = new PortOpeningRequestsDirection().fromValue(obj.direction?.value);
		this.type = new AWSPortOpeningRequestsTypes().fromValue(obj.type?.value);
		this.sendDND = obj.doNotDecrypt;
	}
}